
import { updateclientStatus } from '../actions/Index';

const serverURI = 'https://prepurchase.headout.com';

export const sendRequest = async (endpoint, requestData, token) => fetch(serverURI + endpoint, {
  method: 'POST',
  body: JSON.stringify(requestData),
  headers: {
    Authorization: 'Basic ' + btoa(localStorage.getItem('username') + ':' + localStorage.getItem('password')),
    'Content-type': 'application/json',
  },
});


export const loginRequest = async (endpoint, username, password) => fetch(serverURI + endpoint, {
  method: 'GET',
  headers: {
    Authorization: 'Basic ' + btoa(username + ':' + password),
  },
});


export default sendRequest;



// WEBPACK FOOTER //
// ./src/services/APICall.js